export default function createStockChart(data, elementId, compareWithIndex = false, symbolIndex, isSingleDay) {
  const chart = new AmCharts.AmStockChart();
  chart.language = drupalSettings.path.currentLanguage;
  const currency = data.currency;

  if(isSingleDay) {
    const axis = chart.categoryAxesSettings;
    axis.minPeriod = "mm";
  }

  /**
   * Datasets
   */
  const amrestSet = new AmCharts.DataSet();
  amrestSet.title = "AmRest";
  amrestSet.color = "#FCA22A";
  amrestSet.fieldMappings = [
    {
      fromField: Drupal.t("value"),
      toField: Drupal.t("value")
    },
    {
      fromField: Drupal.t("volume", null, {'context': 'Stock'}),
      toField: Drupal.t("volume")
    }
  ];
  amrestSet.dataProvider = data.amrest;
  amrestSet.categoryField = Drupal.t("date");

  const wigSet = new AmCharts.DataSet();
  wigSet.title = symbolIndex;
  wigSet.compared = compareWithIndex;
  wigSet.fieldMappings = [
    {
      fromField: Drupal.t("value"),
      toField: Drupal.t("value")
    },
    {
      fromField: Drupal.t("volume", null, {'context': 'Stock'}),
      toField: Drupal.t("volume", null, {'context': 'Stock'})
    }
  ];
  wigSet.dataProvider = data.index;
  wigSet.categoryField = Drupal.t("date");


  chart.dataSets = [amrestSet, wigSet];


  /**
   * Configure panels
   */
  const stockPanel1 = new AmCharts.StockPanel();
  stockPanel1.showCategoryAxis = true;
  stockPanel1.title = Drupal.t("Value");
  stockPanel1.percentHeight = 70;
  stockPanel1.fontFamily = "Roboto";

  const graph1 = new AmCharts.StockGraph();
  // TODO
  // uncomment this code for candlestick chart
  // graph1.type = "candlestick";
  // graph1.openField = "open";
  // graph1.closeField = "close";
  // graph1.highField = "high";
  // graph1.lowField = "low";
  // graph1.fillColors = "#7f8da9";
  // graph1.lineColor = "#7f8da9";
  // graph1.lineAlpha = 1;
  // graph1.fillAlphas = 0.9;
  // graph1.negativeFillColors = "#db4c3c";
  // graph1.negativeLineColor = "#db4c3c";
  // graph1.proCandlesticks = true;

  graph1.valueField = "value";
  graph1.fillAlphas = '0.3';
  graph1.comparable = true;
  graph1.compareField = "value";
  graph1.bullet = "none";
  graph1.bulletBorderColor = "#FFFFFF";
  graph1.bulletBorderAlpha = 1;
  graph1.lineThickness = 2;
  graph1.balloonText = `[[title]]: [[value]] ${currency}`;
  // TODO
  // Uncomment line below (and comment live above) to display enchaned data (but not working > 4 months)
  // graph1.balloonText = `<p class="text-align-right mb-0">[[title]]: [[value]]${currency}<br />Open: [[open]]${currency}<br />High: [[high]]${currency}<br />Low: [[low]]${currency}</p>`;
  graph1.compareGraphBalloonText = `[[title]]: [[value]] ${currency}`;
  graph1.compareGraphLineColor = "#b50043"
  graph1.compareGraphLineThickness = 2;
  stockPanel1.addStockGraph(graph1);

  const stockLegend1 = new AmCharts.StockLegend();
  stockLegend1.periodValueTextComparing = "[[percents.value.close]]%";
  stockLegend1.periodValueTextRegular = `[[value.close]] ${currency}`;
  stockLegend1.valueTextRegular = `[[value]] ${currency}`;
  stockPanel1.stockLegend = stockLegend1;

  const stockPanel2 = new AmCharts.StockPanel();
  stockPanel2.title = Drupal.t("Volume", null, {'context': 'Stock'});
  stockPanel2.percentHeight = 30;
  stockPanel2.fontFamily = "Roboto";

  const graph2 = new AmCharts.StockGraph();
  graph2.valueField = Drupal.t("volume", null, {'context': 'Stock'});
  graph2.type = "column";
  graph2.showBalloon = true;
  graph2.fillAlphas = 1;
  stockPanel2.addStockGraph(graph2);

  const stockLegend2 = new AmCharts.StockLegend();
  stockLegend2.periodValueTextRegular = `[[value.close]]`;
  stockLegend2.valueTextRegular = `[[value]]`;
  stockPanel2.stockLegend = stockLegend2;

  chart.panels = [stockPanel1, stockPanel2];

  /**
   * Other
   */
  const sbsettings = new AmCharts.ChartScrollbarSettings();
  // sbsettings.graph = graph1;
  // sbsettings.updateOnReleaseOnly = false;
  // we don't need it at all
  sbsettings.enabled = false;
  chart.chartScrollbarSettings = sbsettings;

  /**
   * Cursor
   */
  var cursorSettings = new AmCharts.ChartCursorSettings();
  cursorSettings.valueBalloonsEnabled = true;
  cursorSettings.categoryBalloonColor = "#FEE3BF";
  cursorSettings.categoryBalloonAlpha = 1;
  cursorSettings.color = "#000";
  chart.chartCursorSettings = cursorSettings;

  /**
   * Render
   */
  chart.write(elementId);
}
